import { urlStoredFilter } from '../../../scripts/utils/urlStoredFilter';
import { WEBINARS_DATA_KEY } from '../../../scripts/config/constants';

export const runWebinarNav = (initType = '', changeFilterSubscribers) =>
  urlStoredFilter({
    initValue: initType,
    dataKey: WEBINARS_DATA_KEY,
    listeners: changeFilterSubscribers,
    isMultiple: true,
  });
